<template>
  <span>
    <el-button type='primary' icon='sys sys-filter' class='navbarbtn'
      @click='showFilterDialogMD()'> 过 滤</el-button>

    <el-dialog v-dialogDrag title='过滤' :visible.sync='showFilterDialogInner' width='765px' top='10px' append-to-body
      lock-scroll>
      <div style='margin-top: -25px;' v-loading='filterLoading'>
        <div v-for='oneFilter in filterInfo' :key='oneFilter.ColumnCode + oneFilter.FilterType' class='vbox'>
          <slot :name='"slot-" + oneFilter.ColumnCode' :oneFilter='oneFilter'>
            <div v-if='oneFilter.DataType === "0" && oneFilter.FilterType === "00"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>等于</div>
              <div class='filterRight'><el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入' size='mini'></el-input></div>
            </div>
            <div v-if='oneFilter.DataType === "0" && oneFilter.FilterType === "01"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>不等于</div>
              <div class='filterRight'><el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入' size='mini'></el-input></div>
            </div>
            <div v-if='oneFilter.DataType === "0" && oneFilter.FilterType === "10"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>包含</div>
              <div class='filterRight'><el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入' size='mini'></el-input></div>
            </div>
            <div v-if='oneFilter.DataType === "0" && oneFilter.FilterType === "11"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>不包含</div>
              <div class='filterRight'><el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入' size='mini'></el-input></div>
            </div>
            <div v-if='oneFilter.DataType === "0" && oneFilter.FilterType === "12"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>左包含</div>
              <div class='filterRight'><el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入' size='mini'></el-input></div>
            </div>
            <div v-if='oneFilter.DataType === "0" && oneFilter.FilterType === "13"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>右包含</div>
              <div class='filterRight'><el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入' size='mini'></el-input></div>
            </div>
            <div v-if='oneFilter.DataType === "0" && oneFilter.FilterType === "14"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>是否为空</div>
              <div class='filterRight'>
                <el-select v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请选择' size='mini'>
                  <el-option v-for='isNull in isNulls' :key='isNull.code' :label='isNull.name' :value='isNull.code'>
                  </el-option>
                </el-select>
              </div>
            </div>

            <div v-if='oneFilter.DataType === "1" && oneFilter.FilterType === "00"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>等于</div>
              <div class='filterRight'><el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入' size='mini' @change='numberChange(oneFilter, "DefaultVal1")'></el-input></div>
            </div>
            <div v-if='oneFilter.DataType === "1" && oneFilter.FilterType === "01"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>不等于</div>
              <div class='filterRight'><el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入' size='mini' @change='numberChange(oneFilter, "DefaultVal1")'></el-input></div>
            </div>
            <div v-if='oneFilter.DataType === "1" && oneFilter.FilterType === "10"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>包含</div>
              <div class='filterRight'>
                <el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入'
                  size='mini' @change='numberChange(oneFilter, "DefaultVal1")'>
                </el-input>
              </div>
              <div class='filterBL'>~</div>
              <div class='filterRight'>
                <el-input v-model='oneFilter.DefaultVal2' class='filterInput' placeholder='请输入'
                  size='mini' @change='numberChange(oneFilter, "DefaultVal2")'>
                </el-input>
              </div>
            </div>
            <div v-if='oneFilter.DataType === "1" && oneFilter.FilterType === "11"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>不包含</div>
              <div class='filterRight'>
                <el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入'
                  size='mini' @change='numberChange(oneFilter, "DefaultVal1")'>
                </el-input>
              </div>
              <div class='filterBL'>~</div>
              <div class='filterRight'>
                <el-input v-model='oneFilter.DefaultVal2' class='filterInput' placeholder='请输入'
                  size='mini' @change='numberChange(oneFilter, "DefaultVal2")'>
                </el-input>
              </div>
            </div>
            <div v-if='oneFilter.DataType === "1" && oneFilter.FilterType === "14"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>是否为空</div>
              <div class='filterRight'>
                <el-select v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请选择' size='mini'>
                  <el-option v-for='isNull in isNulls' :key='isNull.code' :label='isNull.name' :value='isNull.code'>
                  </el-option>
                </el-select>
              </div>
            </div>

            <div v-if='oneFilter.DataType === "1" && oneFilter.FilterType === "20"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>大于</div>
              <div class='filterRight'><el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入' size='mini' @change='numberChange(oneFilter, "DefaultVal1")'></el-input></div>
            </div>
            <div v-if='oneFilter.DataType === "1" && oneFilter.FilterType === "21"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>大于等于</div>
              <div class='filterRight'><el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入' size='mini' @change='numberChange(oneFilter, "DefaultVal1")'></el-input></div>
            </div>
            <div v-if='oneFilter.DataType === "1" && oneFilter.FilterType === "22"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>小于</div>
              <div class='filterRight'><el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入' size='mini' @change='numberChange(oneFilter, "DefaultVal1")'></el-input></div>
            </div>
            <div v-if='oneFilter.DataType === "1" && oneFilter.FilterType === "23"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>小于等于</div>
              <div class='filterRight'><el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入' size='mini' @change='numberChange(oneFilter, "DefaultVal1")'></el-input></div>
            </div>

            <div v-if='oneFilter.DataType === "2" && oneFilter.FilterType === "00"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>等于</div>
              <div class='filterRight'><el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入' size='mini' @change='numberChange(oneFilter, "DefaultVal1")'></el-input></div>
            </div>
            <div v-if='oneFilter.DataType === "2" && oneFilter.FilterType === "01"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>不等于</div>
              <div class='filterRight'><el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入' size='mini' @change='numberChange(oneFilter, "DefaultVal1")'></el-input></div>
            </div>
            <div v-if='oneFilter.DataType === "2" && oneFilter.FilterType === "10"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>包含</div>
              <div class='filterRight'>
                <el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入'
                  size='mini' @change='numberChange(oneFilter, "DefaultVal1")'>
                </el-input>
              </div>
              <div class='filterBL'>~</div>
              <div class='filterRight'>
                <el-input v-model='oneFilter.DefaultVal2' class='filterInput' placeholder='请输入'
                  size='mini' @change='numberChange(oneFilter, "DefaultVal2")'>
                </el-input>
              </div>
            </div>
            <div v-if='oneFilter.DataType === "2" && oneFilter.FilterType === "11"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>不包含</div>
              <div class='filterRight'>
                <el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入'
                  size='mini' @change='numberChange(oneFilter, "DefaultVal1")'>
                </el-input>
              </div>
              <div class='filterBL'>~</div>
              <div class='filterRight'>
                <el-input v-model='oneFilter.DefaultVal2' class='filterInput' placeholder='请输入'
                  size='mini' @change='numberChange(oneFilter, "DefaultVal2")'>
                </el-input>
              </div>
            </div>
            <div v-if='oneFilter.DataType === "2" && oneFilter.FilterType === "14"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>是否为空</div>
              <div class='filterRight'>
                <el-select v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请选择' size='mini'>
                  <el-option v-for='isNull in isNulls' :key='isNull.code' :label='isNull.name' :value='isNull.code'>
                  </el-option>
                </el-select>
              </div>
            </div>
            <div v-if='oneFilter.DataType === "2" && oneFilter.FilterType === "20"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>大于</div>
              <div class='filterRight'><el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入' size='mini' @change='numberChange(oneFilter, "DefaultVal1")'></el-input></div>
            </div>
            <div v-if='oneFilter.DataType === "2" && oneFilter.FilterType === "21"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>大于等于</div>
              <div class='filterRight'><el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入' size='mini' @change='numberChange(oneFilter, "DefaultVal1")'></el-input></div>
            </div>
            <div v-if='oneFilter.DataType === "2" && oneFilter.FilterType === "22"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>小于</div>
              <div class='filterRight'><el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入' size='mini' @change='numberChange(oneFilter, "DefaultVal1")'></el-input></div>
            </div>
            <div v-if='oneFilter.DataType === "2" && oneFilter.FilterType === "23"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>小于等于</div>
              <div class='filterRight'><el-input v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请输入' size='mini' @change='numberChange(oneFilter, "DefaultVal1")'></el-input></div>
            </div>

            <div v-if='oneFilter.DataType === "3" && oneFilter.FilterType === "00"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>等于</div>
              <div class='filterRight'>
                <el-select v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请选择' size='mini'>
                  <el-option v-for='bool in bools' :key='bool.code' :label='bool.name' :value='bool.code'>
                  </el-option>
                </el-select>
              </div>
            </div>
            <div v-if='oneFilter.DataType === "3" && oneFilter.FilterType === "01"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>不等于</div>
              <div class='filterRight'>
                <el-select v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请选择' size='mini'>
                  <el-option v-for='bool in bools' :key='bool.code' :label='bool.name' :value='bool.code'>
                  </el-option>
                </el-select>
              </div>
            </div>
            <div v-if='oneFilter.DataType === "3" && oneFilter.FilterType === "14"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>是否为空</div>
              <div class='filterRight'>
                <el-select v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请选择' size='mini'>
                  <el-option v-for='isNull in isNulls' :key='isNull.code' :label='isNull.name' :value='isNull.code'>
                  </el-option>
                </el-select>
              </div>
            </div>

            <div v-if='oneFilter.DataType === "4" && oneFilter.FilterType === "00"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>等于</div>
              <div class='filterRight'>
                <el-date-picker v-if='oneFilter.DateFormat.length === 4' type='year' v-model='oneFilter.DefaultVal1'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
                <el-date-picker v-if='oneFilter.DateFormat.length === 7' type='month' v-model='oneFilter.DefaultVal1'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
                <el-date-picker v-if='oneFilter.DateFormat.length === 10' type='date' v-model='oneFilter.DefaultVal1'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
                <el-date-picker v-if='oneFilter.DateFormat.length > 10' type='datetime' v-model='oneFilter.DefaultVal1'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
              </div>
            </div>
            <div v-if='oneFilter.DataType === "4" && oneFilter.FilterType === "01"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>不等于</div>
              <div class='filterRight'>
                <el-date-picker v-if='oneFilter.DateFormat.length === 4' type='year' v-model='oneFilter.DefaultVal1'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
                <el-date-picker v-if='oneFilter.DateFormat.length === 7' type='month' v-model='oneFilter.DefaultVal1'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
                <el-date-picker v-if='oneFilter.DateFormat.length === 10' type='date' v-model='oneFilter.DefaultVal1'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
                <el-date-picker v-if='oneFilter.DateFormat.length > 10' type='datetime' v-model='oneFilter.DefaultVal1'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
              </div>
            </div>
            <div v-if='oneFilter.DataType === "4" && oneFilter.FilterType === "10"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>包含</div>
              <div class='filterRight'>
                <el-date-picker v-if='oneFilter.DateFormat.length === 4' type='year' v-model='oneFilter.DefaultVal1'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
                <el-date-picker v-if='oneFilter.DateFormat.length === 7' type='month' v-model='oneFilter.DefaultVal1'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
                <el-date-picker v-if='oneFilter.DateFormat.length === 10' type='date' v-model='oneFilter.DefaultVal1'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
                <el-date-picker v-if='oneFilter.DateFormat.length > 10' type='datetime' v-model='oneFilter.DefaultVal1'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
              </div>
              <div class='filterBL'>~</div>
              <div class='filterRight'>
                <el-date-picker v-if='oneFilter.DateFormat.length === 4' type='year' v-model='oneFilter.DefaultVal2'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
                <el-date-picker v-if='oneFilter.DateFormat.length === 7' type='month' v-model='oneFilter.DefaultVal2'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
                <el-date-picker v-if='oneFilter.DateFormat.length === 10' type='date' v-model='oneFilter.DefaultVal2'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
                <el-date-picker v-if='oneFilter.DateFormat.length > 10' type='datetime' v-model='oneFilter.DefaultVal2'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
              </div>
            </div>
            <div v-if='oneFilter.DataType === "4" && oneFilter.FilterType === "11"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>不包含</div>
              <div class='filterRight'>
                <el-date-picker v-if='oneFilter.DateFormat.length === 4' type='year' v-model='oneFilter.DefaultVal1'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
                <el-date-picker v-if='oneFilter.DateFormat.length === 7' type='month' v-model='oneFilter.DefaultVal1'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
                <el-date-picker v-if='oneFilter.DateFormat.length === 10' type='date' v-model='oneFilter.DefaultVal1'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
                <el-date-picker v-if='oneFilter.DateFormat.length > 10' type='datetime' v-model='oneFilter.DefaultVal1'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
              </div>
              <div class='filterBL'>~</div>
              <div class='filterRight'>
                <el-date-picker v-if='oneFilter.DateFormat.length === 4' type='year' v-model='oneFilter.DefaultVal2'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
                <el-date-picker v-if='oneFilter.DateFormat.length === 7' type='month' v-model='oneFilter.DefaultVal2'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
                <el-date-picker v-if='oneFilter.DateFormat.length === 10' type='date' v-model='oneFilter.DefaultVal2'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
                <el-date-picker v-if='oneFilter.DateFormat.length > 10' type='datetime' v-model='oneFilter.DefaultVal2'
                  :format='oneFilter.DateFormat' align='right' placeholder='选择日期' class='filterInput' size='mini'>
                </el-date-picker>
              </div>
            </div>
            <div v-if='oneFilter.DataType === "4" && oneFilter.FilterType === "14"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>是否为空</div>
              <div class='filterRight'>
                <el-select v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请选择' size='mini'>
                  <el-option v-for='isNull in isNulls' :key='isNull.code' :label='isNull.name' :value='isNull.code'>
                  </el-option>
                </el-select>
              </div>
            </div>

            <div v-if='oneFilter.DataType === "5" && oneFilter.FilterType === "00"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>等于</div>
              <div class='filterRight'>
                <el-select v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请选择' size='mini'>
                  <el-option v-for='specialStr in getSpecialStringArrayInner(oneFilter.ColumnCode)' :key='specialStr.code' :label='specialStr.name' :value='specialStr.code'>
                  </el-option>
                </el-select>
              </div>
            </div>
            <div v-if='oneFilter.DataType === "5" && oneFilter.FilterType === "01"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>不等于</div>
              <div class='filterRight'>
                <el-select v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请选择' size='mini'>
                  <el-option v-for='specialStr in getSpecialStringArrayInner(oneFilter.ColumnCode)' :key='specialStr.code' :label='specialStr.name' :value='specialStr.code'>
                  </el-option>
                </el-select>
              </div>
            </div>
            <div v-if='oneFilter.DataType === "5" && oneFilter.FilterType === "10"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>包含</div>
              <div class='filterRight'>
                <el-select v-model='oneFilter.DefaultVal1' multiple style='width: 430px;' placeholder='请选择' size='mini'>
                  <el-option v-for='specialStr in getSpecialStringArrayInner(oneFilter.ColumnCode)' :key='specialStr.code' :label='specialStr.name' :value='specialStr.code'>
                  </el-option>
                </el-select>
              </div>
            </div>
            <div v-if='oneFilter.DataType === "5" && oneFilter.FilterType === "11"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>不包含</div>
              <div class='filterRight'>
                <el-select v-model='oneFilter.DefaultVal1' multiple style='width: 430px;' placeholder='请选择' size='mini'>
                  <el-option v-for='specialStr in getSpecialStringArrayInner(oneFilter.ColumnCode)' :key='specialStr.code' :label='specialStr.name' :value='specialStr.code'>
                  </el-option>
                </el-select>
              </div>
            </div>
            <div v-if='oneFilter.DataType === "5" && oneFilter.FilterType === "14"' class='hbox filterRow'>
              <div class='filterHeader'>{{oneFilter.Type === '1' ? '且' : '或'}}</div>
              <div class='filterLeft'>{{oneFilter.ColumnName}}</div>
              <div class='filterMid'>是否为空</div>
              <div class='filterRight'>
                <el-select v-model='oneFilter.DefaultVal1' class='filterInput' placeholder='请选择' size='mini'>
                  <el-option v-for='isNull in isNulls' :key='isNull.code' :label='isNull.name' :value='isNull.code'>
                  </el-option>
                </el-select>
              </div>
            </div>
          </slot>
        </div>

        <div class='dialogButtomBtn'>
          <el-button type='primary' @click='filter()' size='mini'>过滤</el-button>
          <el-button @click='cancel()' size='mini'>取消</el-button>
        </div>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import code from '@/components/sys/Code'

export default {
  name: 'TableFilter',
  props: {
    filterLoading: {
      default: false,
      type: Boolean
    },
    filterInfo: {
      default: function () {
        return []
      },
      type: Array
    },
    columnInfo: {
      default: function () {
        return []
      },
      type: Array
    },
    getSpecialStringArray: {
      default: function () {
        return []
      },
      type: Function
    },
    showFilterDialog: {
      default: false,
      type: Boolean
    },
    changeShowFilterDialog: {
      default: false,
      type: Boolean
    }
  },

  data: function () {
    return {
      showFilterDialogInner: false,
      bools: [{ code: 1, name: '是' }, { code: 0, name: '否' }],
      isNulls: [{ code: '1', name: '是' }, { code: '0', name: '否' }]
    }
  },

  watch: {
    showFilterDialog: function (newVal, oldVal) {
      const that = this
      that.showFilterDialogInner = newVal
    },
    changeShowFilterDialog: function (newVal, oldVal) {
      const that = this
      that.showFilterDialogInner = that.$props.showFilterDialog
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  methods: {
    showFilterDialogMD: function () {
      this.$emit('showFilterDialogMD')
    },

    cancel: function () {
      this.showFilterDialogInner = false
    },

    filter: function () {
      this.$emit('filter')
    },

    getSpecialStringArrayInner: function (columnCode) {
      const that = this
      const arys = that.getSpecialStringArray(columnCode)
      if (arys && arys.length > 0) {
        return arys
      } else {
        for (let i = 0; i < that.columnInfo.length; i++) {
          if (that.columnInfo[i].ColumnCode === columnCode) {
            return code.getCode(that.codes, that.columnInfo[i].DateFormat)
          }
        }
      }
    },

    numberChange: function (obj, code) {
      if (obj[code] === '') {
        return
      }
      try {
        obj[code] = parseFloat(obj[code])
        if (isNaN(obj[code])) {
          obj[code] = 0
        }
      } catch (err) {
        obj[code] = 0
      }
    }
  }
}
</script>

<style scoped>
.dialogButtomBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.hbox {
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.vbox {
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.filterRow {
  margin: 3px 0 0 0;
}
.filterHeader {
  width: 40px;
  text-align: right;
  padding: 3px 10px 0px 10px;
  vertical-align: center;
  font-size: 14px;
  color: black;
}
.filterLeft {
  width: 120px;
  text-align: right;
  padding: 3px 10px 0px 10px;
  vertical-align: center;
  font-size: 14px;
  color: black;
}
.filterMid {
  width: 70px;
  text-align: left;
  padding: 3px 10px 0px 10px;
  vertical-align: center;
  font-size: 14px;
  color: blue;
}
.filterMidNo {
  width: 70px;
  text-align: left;
  padding: 3px 10px 0px 10px;
  vertical-align: center;
  font-size: 14px;
  color: red;
}
.filterBL {
  width: 30px;
  font-size: 18px;
}
.filterRight {
  font-size: 14px;
}
.filterInput {
  width: 200px;
}
</style>
